import { Modal } from "sunrise-ui";

const ConfirmationModal = (props: any) => {
  return (
    <Modal
      image="modalImage"
      call={() => {
        if (props.data) {
          props.handleCall(props.data);
        } else {
          props.handleCall();
        }
      }}
      reset={() => props.reset()}
      openModal={props.open}
      title={props.title}
      showImageModal={false}
    />
  );
};

export default ConfirmationModal;
